import script from "./AggregatedProductReturnTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AggregatedProductReturnTable.vue?vue&type=script&setup=true&lang=js"

import "./AggregatedProductReturnTable.vue?vue&type=style&index=0&id=4810655b&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4810655b"]])

export default __exports__